document.addEventListener('DOMContentLoaded', function() {
    // Get the theme switch checkbox and all card elements
    var themeSwitch = document.querySelector('.theme-switch__checkbox');
    var cards = document.querySelectorAll('.flip-container');

    // Add event listener to the theme switch checkbox
    themeSwitch.addEventListener('change', function() {
        const section = document.getElementById('team-section');
        section.classList.toggle('flipper');
        const header = section.querySelector('.heading__value');
        const message = section.querySelector('.switch__msg');
        // header.classList.toggle('flipped__text');
        // Toggle the 'flipped' class on all card elements
        cards.forEach(function(card) {
            card.classList.toggle('flipped');
        });
    });
});